import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const HelpContentLibrary = ({ content, onContentClick, userRole }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', label: 'All Topics', icon: 'BookOpen' },
    { id: 'getting_started', label: 'Getting Started', icon: 'PlayCircle' },
    { id: 'features', label: 'Features', icon: 'Zap' },
    { id: 'troubleshooting', label: 'Troubleshooting', icon: 'AlertCircle' },
    { id: 'best_practices', label: 'Best Practices', icon: 'Award' }
  ];

  const filteredContent = content?.filter(item => {
    const matchesSearch = item?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                         item?.content?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || item?.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const getCategoryIcon = (category) => {
    const cat = categories?.find(c => c?.id === category);
    return cat?.icon || 'BookOpen';
  };

  const getCategoryColor = (category) => {
    const colorMap = {
      getting_started: 'primary',
      features: 'accent',
      troubleshooting: 'warning',
      best_practices: 'success'
    };
    return colorMap?.[category] || 'primary';
  };

  return (
    <div className="flex flex-col h-full">
      {/* Search & Filters */}
      <div className="p-4 border-b border-border bg-background space-y-3">
        <Input
          type="text"
          placeholder="Search help articles..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e?.target?.value)}
          icon="Search"
        />
        <div className="flex gap-2 overflow-x-auto pb-2">
          {categories?.map(cat => (
            <button
              key={cat?.id}
              onClick={() => setSelectedCategory(cat?.id)}
              className={`px-3 py-1.5 rounded-lg text-xs font-medium whitespace-nowrap flex items-center gap-1.5 transition-colors ${
                selectedCategory === cat?.id
                  ? 'bg-primary text-white' :'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
            >
              <Icon name={cat?.icon} size={14} />
              {cat?.label}
            </button>
          ))}
        </div>
      </div>
      {/* Content List */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {filteredContent?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Search" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-3" />
            <p className="text-sm text-muted-foreground">No help articles found</p>
          </div>
        ) : (
          filteredContent?.map(item => (
            <div
              key={item?.id}
              onClick={() => onContentClick(item)}
              className="bg-muted/50 hover:bg-muted rounded-lg p-4 cursor-pointer transition-colors"
            >
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded-lg bg-${getCategoryColor(item?.category)}/10 flex items-center justify-center flex-shrink-0`}>
                  <Icon
                    name={getCategoryIcon(item?.category)}
                    size={20}
                    color={`var(--color-${getCategoryColor(item?.category)})`}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground mb-1">{item?.title}</h3>
                  <p className="text-xs text-muted-foreground line-clamp-2 mb-2">{item?.content}</p>
                  <div className="flex items-center gap-2">
                    <span className={`px-2 py-0.5 rounded text-xs font-medium bg-${getCategoryColor(item?.category)}/10 text-${getCategoryColor(item?.category)}`}>
                      {item?.category?.replace('_', ' ')}
                    </span>
                    {item?.role && (
                      <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent/10 text-accent capitalize">
                        {item?.role}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default HelpContentLibrary;